import React from "react";
import CheckboxRadioWrapper, {
  CheckboxRadioWrapperProps,
} from "./CheckboxRadioWrapper";

export default function WPCheckbox(props: CheckboxRadioWrapperProps<boolean>) {
  return <CheckboxRadioWrapper {...props} type="radiobutton" />;
}
